import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { userActions } from '../_actions';
import Header from '../_components/Header';
import InputFile from '../_components/InputFile';
import Group177 from '../_assets/new/Group177.png';
import logoutIcon from '../_assets/new/logout.png';
import { Users } from './Users';
import { News } from './News';
import iconPerson from '../_assets/new/person.png';
import iconNews from '../_assets/new/newspaper.png';

const Profile = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.users.userProfile);

  function logout() {
    dispatch(userActions.logout());
  }

  return (
    <div className="profile-container">
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-md-3 offset-md-1">
            <div className="slide-left">
              <div className="padding text-center">
                <InputFile
                  path={data?.business_data?.logo || Group177}
                  name="input-logo"
                  path-to-upload="user/business/profile/logo/"
                />

                <br />

                <strong className="name ">Huixquilucan</strong>
                <p className="profession ">Bolsa de trabajo virtual</p>
              </div>

              <div className="profile-links">
                <nav className="nav flex-column">
                  <NavLink className="nav-link" to="team">
                    <img src={iconPerson} alt="" /> Administrar equipo
                  </NavLink>
                  <NavLink className="nav-link" to="news">
                    <img src={iconNews} alt="" /> Subir noticias
                  </NavLink>
                </nav>
              </div>

              <div className="logout pointer" onClick={logout}>
                Cerrar sesión
                <img src={logoutIcon} alt="" />
              </div>
            </div>
          </div>
          <div className="col-md-6 offset-md-1">
            <div className="slide-right">
              <Routes>
                <Route index element={<Navigate to="team" replace />} />
                <Route path="team" element={<Users />} />
                <Route path="news" element={<News />} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
